import { FunctionComponent } from 'react';

const style = { backgroundColor: '#000', width: '100vw', height: '100vh' };

export const Fallback: FunctionComponent = () => {
  return <div style={style}></div>;
};
